"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props, avatarUrl) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$background = props.background,
    background = _props$background === void 0 ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light : _props$background;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    fontSizeProps = _useStylesUtils.fontSizeProps,
    getElementHeight = _useStylesUtils.getElementHeight;
  var ccAvatarStyle = (0, _react.useMemo)(function () {
    var sizeProps = function sizeProps() {
      var height = getElementHeight(size);
      var width = height;
      return {
        height: height,
        width: width
      };
    };
    var ccAvatar = (0, _css.css)(_objectSpread(_objectSpread({
      fontFamily: fontFamily,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      background: background,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      flex: 'none',
      borderRadius: '50%',
      overflow: 'hidden',
      position: 'relative'
    }, fontSizeProps(size)), sizeProps()));
    var ccAvatarImage = (0, _css.css)({
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: "url('".concat(avatarUrl, "')")
    });
    return {
      ccAvatar: ccAvatar,
      ccAvatarImage: ccAvatarImage
    };
  }, [avatarUrl, fontFamily, fontSizeProps, getElementHeight, background, size, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-Avatar': ccAvatarStyle.ccAvatar,
    'cc-Avatar__image': ccAvatarStyle.ccAvatarImage
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;